import { Button } from "@/components/ui/Button";

function InfoField({
  label,
  value,
  mono,
}: {
  label: string;
  value: string;
  mono?: boolean;
}): JSX.Element {
  return (
    <div>
      <dt className="text-xs font-medium uppercase tracking-wide text-slate-500">{label}</dt>
      <dd className={mono ? "mt-0.5 font-mono text-slate-900" : "mt-0.5 text-slate-900"}>{value || "—"}</dd>
    </div>
  );
}

export function ConfigurationJobTargets({
  targetSku,
  requiredTlaSku,
  requiredTlaLoading,
  showClearForm,
  onClearForm,
  showPreConfigQcIncident,
  preConfigQcDisabled,
  onPreConfigQcIncident,
}: {
  targetSku: string;
  requiredTlaSku: string | null;
  requiredTlaLoading: boolean;
  showClearForm: boolean;
  onClearForm?: () => void;
  showPreConfigQcIncident?: boolean;
  preConfigQcDisabled?: boolean;
  onPreConfigQcIncident?: () => void;
}): JSX.Element {
  return (
    <div className="flex flex-wrap items-start justify-between gap-x-3 gap-y-2">
      <dl className="grid min-w-0 flex-1 gap-3 text-sm sm:grid-cols-2">
        <InfoField
          label="Required TLA"
          value={requiredTlaLoading ? "Loading…" : requiredTlaSku ?? "—"}
          mono
        />
        <InfoField label="Target SKU" value={targetSku} mono />
      </dl>
      <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
        {showPreConfigQcIncident && onPreConfigQcIncident ? (
          <Button
            type="button"
            variant="secondary"
            className="h-9 touch-manipulation px-3 text-sm font-medium"
            disabled={preConfigQcDisabled}
            onClick={onPreConfigQcIncident}
          >
            Pre-configuration QC incident
          </Button>
        ) : null}
        {showClearForm && onClearForm ? (
          <Button
            type="button"
            variant="secondary"
            className="h-9 touch-manipulation px-3 text-sm font-medium"
            onClick={onClearForm}
          >
            Clear form
          </Button>
        ) : null}
      </div>
    </div>
  );
}
